export const INCREMENT = 'INCREMENT' //添加
export const DECREMENT = 'DECREMENT' //减少
export const LOGIN= 'LOGIN'
export const LOGINOUT = 'LOGINOUT'
//登出


// WEBPACK FOOTER //
// ./src/store/mutations-types.js